import { render, staticRenderFns } from "./ArchiveSubfolders.vue?vue&type=template&id=693b54ac&"
import script from "./ArchiveSubfolders.vue?vue&type=script&lang=js&"
export * from "./ArchiveSubfolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports